/**
 * contact us modal
 */
(() => {
  const modal = document.getElementById('myContactModal');
  const btn = document.querySelectorAll('.contact-link');
  const span = document.querySelectorAll('.contact-us-modal .close');

  if (!btn) {
    return;
  }

  const form = document.querySelector('.js-modal-contact-form');
  form.classList.remove('hidden');
  document.querySelector('.js-contact-us').append(form);
  document.querySelector('.js-contact-us form > button').innerHTML = 'Submit';

  // Open the modal when button is clicked
  btn.forEach((button) => {
    button.onclick = (e) => {
      e.preventDefault();
      modal.classList.add('nActive');
    };
  });

  // Close the modal when 'x' is clicked
  span.forEach((close) => {
    close.onclick = () => {
      modal.classList.remove('nActive');
    };
  });

  // Close the modal when user clicks outside of it
  window.onclick = (event) => {
    if (event.target === modal) {
      modal.classList.remove('nActive');
    }
  };
})();
